export default "__VITE_ASSET__hv3YhXAh__"